import { render, staticRenderFns } from "./FaturaDetails.vue?vue&type=template&id=6993c14e"
import script from "./FaturaDetails.vue?vue&type=script&lang=js"
export * from "./FaturaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports